import React from 'react';
import PropTypes from 'prop-types';

const PaginationSection = ({
  queryResult,
  changePage,
  PaginationComponent,
}) => {
  return (
    <PaginationComponent
      totalPages={queryResult.data.total_pages}
      totalElements={queryResult.data.total_records}
      maxVisibleNumbers={6}
      currentPage={queryResult.data.page}
      elementsPerPage={queryResult.data.page_size}
      changePage={page => {
        changePage(page);
      }}
    />
  );
};

PaginationSection.propTypes = {
  queryResult: PropTypes.object.isRequired,
  changePage: PropTypes.func.isRequired,
  PaginationComponent: PropTypes.elementType.isRequired,
};

export default PaginationSection;
